import { useValueFormatter } from "@/utils/useValueFormatter";

export function useSigned() {
  const { format } = useValueFormatter();
  return (tokens: number) => `${tokens > 0 ? "+" : "−"}${format(Math.abs(tokens), "decimal")}`;
}
